<template>
  <transition name="tabs" @leave="rerender">
    <div class="previous__categories" v-if="ready">
      <PreviousContestItem
        v-for="(category, i) in categories"
        :key="i"
        :category="category"
      />
    </div>
  </transition>
</template>

<script>
import PreviousContestItem from '~/components/PreviousContestItem.vue'

export default {
  props: {
    year: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      categories: [],
      ready: true
    }
  },
  components: {
    PreviousContestItem
  },
  methods: {
    createCategories() {
      this.categories = Object.values(this.year)
    },
    rerender(el, done) {
      this.ready = true
      done()
    }
  },
  watch: {
    year: {
      handler() {
        this.ready = false
        this.createCategories()
      },
      immediately: true
    }
  },
  created() {
    this.createCategories()
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// components/PreviousContestCategory.vue